import type {
  GetColumnKeys,
  GetColumnOptions,
  ColumnOptions,
} from 'client/js/main/selectors/Analytics/createColumnsSelector.types';
import { createSelector } from 'reselect';
import type { IColumn } from 'client/js/common/types/IColumn';
import { DYNAMIC_CALCULATION_METADATA_TYPE } from 'client/js/main/selectors/Analytics/getDynamicCalculationColumns';
import { buildColumn } from 'client/js/common/support/utils';
import { DATA_FIELD_KEY_SEPARATOR, DYNAMIC_CALCULATION_DATA_FIELD_KEY_PREFIX } from '../../../../../shared/constants';
import { COLUMN_FORMAT } from 'client/libraries/branch-neo-next/DataGrid/LinkManager/constants/columnFormat';

const getDynamicCalculationCustomEventColumns = (
  dynamicCalculationsKeys: string[],
  customEvents: string[],
  options?: ColumnOptions
): IColumn[] => {
  return dynamicCalculationsKeys.reduce((dynamicCalculationCustomEventColumns, dynamicCalculationsKey) => {
    const dynamicCalculationColumnForCustomEvent = customEvents.map((customEvent) => {
      const columnKey = `${DYNAMIC_CALCULATION_DATA_FIELD_KEY_PREFIX}${dynamicCalculationsKey}${DATA_FIELD_KEY_SEPARATOR}${customEvent}`;
      const columnType = dynamicCalculationsKey
        ? DYNAMIC_CALCULATION_METADATA_TYPE[dynamicCalculationsKey]
        : COLUMN_FORMAT.PERCENTAGE;
      return buildColumn({ type: columnType, key: columnKey, ...options });
    });
    return [...dynamicCalculationCustomEventColumns, ...dynamicCalculationColumnForCustomEvent];
  }, [] as IColumn[]);
};

export const createDynamicCalculationCustomEventColumnsSelector = (
  getDynamicCalculationsKeys: GetColumnKeys,
  getCustomEventKeys: GetColumnKeys,
  getColumnOptions: GetColumnOptions = () => undefined
) => {
  return createSelector(
    getDynamicCalculationsKeys,
    getCustomEventKeys,
    getColumnOptions,
    getDynamicCalculationCustomEventColumns
  );
};
